import { ProductDropdownDomes } from "./products/domes";
import { ProductDropdownReceivers } from "./products/receivers";
import { ProductDropdownTubes } from "./products/tubes";

export class ProductDropdown extends HTMLElement {
    constructor() {
        super();
        this._refs = {
            elem: this,
            contentAccessory: this.parentElement.querySelector('.eTableWrapper.configurator__accessories-list'), 
            bundle: false,
            selectedItems: [],
            data: [],
            config: { attributes: true },
            sideAttribute: '',
            accessoryType: '',
            labels: {}
        }
    }
    
    getLabels() {
        this._refs.labels = {
            title: this.getAttribute('title'),
            buttonLabel: this.getAttribute('button-label'),
            selectLeft: this.getAttribute('dropdown-label-left') ?? 'Select left',
            selectRight: this.getAttribute('dropdown-label-right')  ?? 'Select right',
            selectDome: this.getAttribute('dropdown-label-dome')  ?? 'Select dome',
        }
    }

    getAccessoryType() {
        const contentItems = Array.from(this._refs.contentAccessory?.querySelectorAll('.configurator__accessories-item'));
        return this.checkType(contentItems);
    }

    checkType(listItems) {
        const listOfAttributes = [
            {
                type: 'receivers',
                identifier: ['data-filter-side']
            }, 
            {
                type: 'tubes',
                identifier: ['data-filter-tubeside', 'data-filter-sideproperty']
            }, 
            {
                type: 'domes',
                identifier: ['data-filter-dome_type', 'data-filter-dome_size']
            }
        ];
        for(let attr of listOfAttributes) {
            for(let id of attr.identifier) {
                if(listItems[0].getAttribute(id)) {
                    return attr;
                }
            }
        }
    }

    async connectedCallback() {
        this.getLabels();
        const elem = this;
        const accessoryType = this.getAccessoryType();
        // check if Dome / receiver / tube
        if(!accessoryType) return
        this._refs.accessoryType = accessoryType.type;
        switch(accessoryType.type) {
            case 'receivers': 
                await new ProductDropdownReceivers(elem, this._refs);
            break;
            case 'tubes':
                await new ProductDropdownTubes(elem, this._refs);
            break;
            case 'domes':
                await new ProductDropdownDomes(elem, this._refs);
            break;
        }
    }
}